import { render } from "./MainMs.vue?vue&type=template&id=2ee38992"
import script from "./MainMs.vue?vue&type=script&lang=js"
export * from "./MainMs.vue?vue&type=script&lang=js"

import "./MainMs.vue?vue&type=style&index=0&id=2ee38992&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__